export const REGISTERING_LOADER = 'REGISTERING_LOADER';
export const MANUAL_REGISTERING_LOADER = 'MANUAL_REGISTERING_LOADER';
export const REGISTRATION_FAILED_POPUP_REGISTER_LOADER = 'REGISTRATION_FAILED_POPUP_REGISTER_LOADER';
export const DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER = 'DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER';
export const CLEANING_MODE_PAGE_LOADER = 'CLEANING_MODE_PAGE_LOADER';
export const LOCATE_MY_DEVICE_PAGE_LOADER = 'LOCATE_MY_DEVICE_PAGE_LOADER';
export const REDIRECT_LOADER_NAME = 'REDIRECT_LOADER_NAME';
export const PAIRING_IN_PROGRESS_LOADER = 'PAIRING_IN_PROGRESS_LOADER';
export const TNC_PAGE_LOADER = 'TNC_PAGE_LOADER';
export const SCP_CHECK_LOADER = 'SCP_CHECK_LOADER';
export const DEVICE_LIST_LOADER = 'DEVICE_LIST_LOADER';
export const LOADER_RESET = 'LOADER_RESET';
export const USAGE_LOADER = 'USAGE_LOADER';
export const DEVICE_SYNC = 'DEVICE_SYNC';
